module.exports = __webpack_public_path__ + "img/hohlsaum_weiss_candy.0388b8fe.jpg";